// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type OrgView = {
  id: string;
  name: string;
  slug: string;
  plan: string;
  status: string;
  kind: "personal" | "team";
};
export const OrgViewSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  plan: z.string(),
  status: z.string(),
  kind: z.enum(["personal", "team"] as const),
}).strict();

export type SelfCreateOrgBody = {
  name: string;
  kind?: "personal" | "team" | undefined;
  planSlug?: "free" | "pro" | undefined;
};
export const SelfCreateOrgBodySchema = z.object({
  name: z.string().min(1).max(200),
  kind: z.enum(["personal", "team"] as const).default("team"),
  planSlug: z.enum(["free", "pro"] as const).default("free"),
}).strict();

export type ConvertOrgBody = {
  name: string;
  planSlug?: "free" | "pro" | undefined;
};
export const ConvertOrgBodySchema = z.object({
  name: z.string().min(1).max(200),
  planSlug: z.enum(["free", "pro"] as const).optional(),
}).strict();

export type SelfCreateOrgResponse = {
  data: OrgView;
  checkoutUrl: string | null;
};

export async function selfCreateOrg(body: SelfCreateOrgBody): Promise<SelfCreateOrgResponse> {
  const response = await api.post<SelfCreateOrgResponse>(`/orgs`, body);
  return response.data;
}

export type ConvertOrgResponse = {
  data: OrgView;
  checkoutUrl: string | null;
  converted: boolean;
};

export const ConvertOrgParamsSchema = z.object({
  orgId: z.string().regex(new RegExp("^[0-9a-fA-F]{24}$"), "must be a Mongo ObjectId"),
});

export async function convertOrg(orgId: string, body: ConvertOrgBody): Promise<ConvertOrgResponse> {
  const response = await api.post<ConvertOrgResponse>(`/orgs/${encodeURIComponent(orgId)}/convert`, body);
  return response.data;
}

export const orgsKeys = {
  all: ["orgs"] as const,
  lists: () => [...orgsKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...orgsKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...orgsKeys.all, 'detail'] as const,
  detail: (id: string) => [...orgsKeys.details(), id] as const,
};
